import { RouteItem } from '@eastcoal/router/types/route'

import { LoginPage } from './index'

export const loginRoute: RouteItem = {
  title: '账号登录',
  path: '/login',
  hideInMenu: true,
  element: <LoginPage />
}
